import React, { FC, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import {
  AppState,
  Auth0Provider as Auth0ProviderComponent,
} from '@auth0/auth0-react'

import { env } from 'common/config/env'

const Auth0Provider: FC<{ children?: React.ReactNode }> = ({ children }) => {
  const history = useHistory()

  const audience = env.auth0Audience
  const clientId = env.auth0ClientId
  const domain = env.auth0Domain

  const onRedirectCallback = useCallback(
    (appState?: AppState): void => {
      history.push(appState?.returnTo || `${window.location.pathname}`)
    },
    [history]
  )

  const getRedirectUri = () => {
    const url = window.location.href
    const origin = window.location.origin

    if (url.includes('error=access_denied')) {
      if (url.includes('error_description=RESET_PASSWORD')) {
        return `${origin}/expired-password`
      }
      return `${origin}/logout-sso`
    }

    return origin
  }

  return (
    <Auth0ProviderComponent
      clientId={clientId}
      domain={domain}
      authorizationParams={{
        redirect_uri: getRedirectUri(),
        audience,
      }}
      onRedirectCallback={onRedirectCallback}
      /*
        when embedded in an iframe (SFMC) the silent-auth cookie is
        third-party and the SFMC OAuth round-trip reloads the app, so tokens
        must persist in localstorage; top-level prod keeps the in-memory cache
      */
      cacheLocation={
        import.meta.env.DEV || window.self !== window.top
          ? 'localstorage'
          : 'memory'
      }
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
    >
      {children}
    </Auth0ProviderComponent>
  )
}

export default Auth0Provider
